import { render, staticRenderFns } from "./EditarTicketTableActions.vue?vue&type=template&id=b5ce6214"
import script from "./EditarTicketTableActions.vue?vue&type=script&lang=js"
export * from "./EditarTicketTableActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports